<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">        
      
      <el-form :inline="true" class="backborder1 demo-form-inline" ref="query" :model="query" size="small">
      	  <el-form-item>
      	  	  <el-cascader :options="mallcategorylist" v-model="query.catid" clearable placeholder="请选择分类" @change="isselect=true"></el-cascader>
      	  </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getlists">查询</el-button>
              <el-button type="danger" icon="el-icon-plus" @click="addcatids">新增</el-button>
          </el-form-item>
      </el-form>
      
      <div class="backborder2" style="margin-top:10px">
	      <el-table :data="lists" v-loading="listsloading">
	      	    <el-table-column type="expand">
		            <template slot-scope="props">
		                <el-table :data="props.row.child">
			                <el-table-column prop="labelname" label="绑定标签名称"></el-table-column>
			                <el-table-column label="操作" width="150" align="center">
					            <template slot-scope="scope">
					                <el-button type="danger" size="small" icon="el-icon-delete" circle @click="delsingle(props.row.catid,scope.row)"></el-button>
					            </template>
				            </el-table-column>	 
		                </el-table>
		            </template>
	            </el-table-column>
	            <el-table-column prop="catidsname" label="分类名称"></el-table-column>
	            <el-table-column label="操作" width="150" align="center">
		            <template slot-scope="scope">
		                <el-button type="danger" size="small" icon="el-icon-delete" circle @click="del(scope.row)"></el-button>
		            </template>
	            </el-table-column>	          	            
	      </el-table>
	      <div class="block">
	      	  <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="listsrow">
	          </el-pagination>
	          <!--分页end-->
	      </div>
      </div>
      
      <!---------------- 新增线上商城商品分类 ----------------->
      <el-dialog title="绑定线上商城商品分类" :visible.sync="addDialog" width="20%" top="25vh">
      	  <el-form ref="create" :model="create" size="small">
      	  	  <el-col :span="24">
		      	  <el-form-item style="width:100%">
		          	  <el-cascader :options="mallcategorylist" v-model="create.catid" clearable></el-cascader>
		          </el-form-item>
	          </el-col>
	          <el-col :span="24">
		      	  <el-form-item style="width:100%">
		          	  <el-select v-model="create.labelid" filterable clearable placeholder="请选择标签">
		              	  <el-option v-for="(item,index) in catelists" :label="item.name" :value="item.id" :key="index"></el-option>
		              </el-select>
		          </el-form-item>
	          </el-col>
      	  </el-form>
      	   <div slot="footer" class="dialog-footer">
      	  	  <el-button @click="addDialog=false" size="small">取消</el-button>
      	  	  <el-button type="primary" @click="addcreate" size="small" :loading="addLoading">确定</el-button>
      	  </div>
      </el-dialog>
      
      
  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Labelsetting/index",
      transitionshow:true,
      listsloading:false,
      lists:[],
      listsrow:0,
      isselect:false,
      query: {
      	  act:'getlabelcates',
      	  token:this.$cookies.get('token'),
      	  labelid:'',
      	  catid:[],
      	  p:1,
      	  rollpage:10,
      },
      addDialog:false,
      addLoading:false,
      create: {
      	  act:'addlabelcatid',
      	  token:this.$cookies.get('token'),
      	  labelid:'',
      	  catid:[],
      },
      mallcategorylist:[],
      catelists:[],
      catequery: {
      	  act:'getcatelists',
		  token:this.$cookies.get('token'),
		  parentid:'a0'
      },
      
    }  
  },
  
  mounted(){
  	  this.getmallCategoryList(); //获取线上商城的分类	
  	  this.getcatelists(); //获取标签信息列表
  	  this.getlists();
  },
  
  methods:{
  
  	 //获取标签分类列表
  	 getcatelists() {
  	     var resource = this.$resource(this.url);
         resource.query(this.catequery).then((res) => {
             if(res.data.Result>0){
                 if(res.data.Result=='70001') this.$router.push('/login')
                 this.$message.error(res.data.Message);
             }else{
                 this.catelists=JSON.parse(Base64.decode(res.data.Data));
             }
         }).catch((res) => {
             //this.$message.error(this.GLOBAL.errortext);
         }); 
  	 },
  	 
  	 //获取线上商城分类列表
	 getmallCategoryList(){
	     var resource = this.$resource(this.GLOBAL.domain+"Product/index");
	     resource.query({ act:'getmallcatelist',token:this.$cookies.get('token')}).then((res) => {
		     if(res.data.Result>0){
		         if(res.data.Result=='70001') this.$router.push('/login')
		         this.$message.error(res.data.Message);
		     }else{
		         this.mallcategorylist = JSON.parse(Base64.decode(res.data.Data));
		     }
	     }).catch((res) => {
	            
	     });
	 },
	 
	 //获取绑定的商品分类列表
	 getlists() {
	 	 if(this.isselect==true) {
	 	 	this.query.p=1;
	 	 	this.query.rollpage=10;
	 	 }
	 
	 	 this.listsloading=true;
	 	 var resource = this.$resource(this.url);
	     resource.query(this.query).then((res) => {
		     if(res.data.Result>0){
		         if(res.data.Result=='70001') this.$router.push('/login')
		         this.$message.error(res.data.Message);
		         this.listsloading=false;
		     }else{
		         this.lists = JSON.parse(Base64.decode(res.data.Data));
		         this.listsrow=parseInt(res.data.count);
		         this.listsloading=false;
		         
		         if(this.isselect==true) this.isselect=false;
		     }
	     }).catch((res) => {
	         this.listsloading=false;
	     });
	 },
	 
	 pageSizeChange(val) {
         this.query.rollpage = val;
         this.getlists();
     },
     pageCurrentChange(val) {
         this.query.p = val;
         this.getlists();
     }, 
  	 
  	 //新增标签绑定分类信息
  	 addcatids() {
  	 	 this.create.catid=[];
  	 	 this.create.labelid='';
  	 	 this.addDialog=true;
  	 },
  	 
  	 //保存标签商品分类
  	 addcreate() {
  	 	 this.addLoading=true;
  	 	 var resource = this.$resource(this.url);
	     resource.save(this.create).then((res) => {
		     if(res.data.Result>0){
		         if(res.data.Result=='70001') this.$router.push('/login')
		         this.$message.error(res.data.Message);
		         this.addLoading=false;
		     }else{
		     	 this.$message.success('绑定商品分类成功!');
		         this.addLoading=false;
		         this.addDialog=false;
		         this.getlists();
		     }
	     }).catch((res) => {
	         this.addLoading=false;     
	     });
  	 },
  	 
  	 //删除分类绑定的标签
  	 delsingle(catid,item) {
  	    this.$confirm('您是否要删除标签： ' + item.labelname + ', 是否继续?', '提示', { type: 'warning' }).then(() => {        	
 			var resource = this.$resource(this.url);
		     resource.save({act:'delsingle',token:this.$cookies.get('token'),catid:catid,labelid:item.labelid}).then((res) => {
			     if(res.data.Result>0){
			         if(res.data.Result=='70001') this.$router.push('/login')
			         this.$message.error(res.data.Message);
			     }else{
			     	 this.$message.success('绑定商品分类成功!');
			         this.getlists();
			     }
		     }).catch((res) => {
		          
		     });
        	
        }).catch(() => {
            //this.$message.info('已取消操作!');
        });
  	 },
  	 
  	 
  	 //删除分类绑定的标签
  	 del(item) {
  	    this.$confirm('您是否要删除分类： ' + item.catidsname + '绑定的所有标签, 是否继续?', '提示', { type: 'warning' }).then(() => {        	
 			var resource = this.$resource(this.url);
		     resource.save({act:'dellabel',token:this.$cookies.get('token'),catid:item.catid}).then((res) => {
			     if(res.data.Result>0){
			         if(res.data.Result=='70001') this.$router.push('/login')
			         this.$message.error(res.data.Message);
			     }else{
			     	 this.$message.success('绑定商品分类成功!');
			         this.getlists();
			     }
		     }).catch((res) => {
		          
		     });
        	
        }).catch(() => {
            //this.$message.info('已取消操作!');
        });
  	 },
  	 
  	  
  }
  
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/mall/Labelandcatid.vue